import { DetailedHTMLProps, FC, InputHTMLAttributes } from "react"
import styles from "./index.module.scss"




interface IProps extends DetailedHTMLProps<
    InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
> {}


const Checkbox: FC<IProps> = ({ className, children, ...rest }) => {
    return (
        <label className={styles.checkbox + ` ${className ?? ""}`}>
            <input
                {...rest}
                type="checkbox"
                className={styles.input__checkbox}
            />
            <div className={styles.box__checkbox + ` box ${rest.checked ? styles.checked__box : ""}`} />

            <span className={styles.label__checkbox}>
                {children}
            </span>
        </label>
    )
}

export default Checkbox